import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchCalendars } from '../actions/calendars'
import { fetchCustomer } from '../actions/customers'


import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import CalendarsList from '../components/CalendarsList'
import FeatureBlockedScreen from '../components/FeatureBlockedScreen';
import '../styles/CalendarsView.css';

class CalendarsView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filterName: ""
    }

    this.refreshCalendars = this.refreshCalendars.bind(this);
  }

  componentDidMount() {
    const { role, customerId } = this.props;
    this.props.fetchCalendars();
    if (role === 'CUSTOMER' && customerId) {
      this.props.fetchCustomer(customerId);
    }
  }

  refreshCalendars() {
    this.props.fetchCalendars()
  }

  renderCalendars() {
    const { calendars, error, loading } = this.props
    const { filterName } = this.state

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!calendars || loading) {
      return <LoadingProgress />;
    }

    const filtered = calendars.filter(c => (c.Name || '').toLowerCase().includes(filterName.toLowerCase()))

    return (<CalendarsList calendars={filtered} refreshCalendars={this.refreshCalendars}/>)
  }

  render() {
    const { filterName } = this.state
    const { role, customer } = this.props

    if (role === 'CUSTOMER' && customer && customer.FeatureCalendars === false) {
      return (
        <FeatureBlockedScreen featureName="FeatureCalendars" featureLabel="Calendarios de Precios" />
      );
    }

    return (
      <div className="calendars-view">
        {/* Header Section */}
        <div className="calendars-header">
          <div className="calendars-title-section">
            <h1 className="calendars-title">
              <i className="fas fa-calendar-alt"></i>
              CALENDARIOS DE PRECIOS
            </h1>
          </div>
          <div className="calendars-actions">
            <input
              type="text"
              className="filter-input"
              placeholder="Filtrar por Nombre"
              value={filterName}
              onChange={(e) => this.setState({ filterName: e.target.value })}
              style={{ width: "220px" }}
            />
            <Link to="/calendars/add">
              <button type="button" className="btn btn-vw btn-action">
                <i className="fas fa-plus mr-2"></i>
                Nuevo
              </button>
            </Link>
          </div>
        </div>

        <div className="calendars-card">
          <div className="card-header-custom">
            <i className="fas fa-list mr-2"></i>
            Listado de Calendarios
          </div>
          <div className="card-body-custom">
            {this.renderCalendars()}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  role: state.auth.role,
  customerId: state.auth.id,
  customer: state.customers.customer,
  calendars: state.calendars.calendars,
  error: state.calendars.error,
  loading: state.calendars.loading,
  form: state.form
})

const mapDispatchToProps = dispatch => ({
  fetchCalendars: bindActionCreators(fetchCalendars, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CalendarsView)


